// extracted by mini-css-extract-plugin
export var animationContainer = "_hw-0";
export var asteriskIcon = "_hw-8";
export var conversationLeftSection = "_hw-4";
export var conversationListItem = "_hw-3";
export var conversationMiddleSection = "_hw-5";
export var conversationRightSection = "_hw-6";
export var detailsContent = "_hw-1";
export var listContainer = "_hw-7";
export var modalContent = "_hw-2";